// import submitSchema from './submitSchema';

const yup = require('yup');


// import enrolmentSchema from './enrolment';

import programSchema from './program';
import personalSchema from './data/personal';
import studiesSchema from './data/studies';
import paymentSchema from './data/payment';

/**
 *
 * @param {[]} values
 * @param {?Program} program
 * @param {Program[]} programs
 * @param {Country[]} countries
 * @param {Location[]} locations
 * @returns {Object}
 */
export default (currentProgram, programs, countries, locations) =>
  currentProgram
    ? yup.object().shape({
        personal: personalSchema({countries}).required(),
        // studies: studiesSchema({currentProgram, programs}).required(),
        payment: paymentSchema({countries}).required()
      })
    : yup.object().shape({
        program: programSchema(currentProgram, programs).required(),
      });
